var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgWind = function SvgWind(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.134 16a3.963 3.963 0 0 1 3.835 2.957 4.02 4.02 0 0 1-1.843 4.508 3.922 3.922 0 0 1-4.78-.645 1.345 1.345 0 0 1 .005-1.886 1.308 1.308 0 0 1 1.78-.073l.084.078a1.308 1.308 0 0 0 1.594.215 1.34 1.34 0 0 0 .615-1.502c-.147-.549-.62-.94-1.179-.982l-.105-.003H1.318A1.326 1.326 0 0 1 0 17.333c0-.703.538-1.279 1.22-1.33L1.318 16h15.816Zm9.56-11.374a4.689 4.689 0 0 1 2.15 5.245 4.626 4.626 0 0 1-4.284 3.46l-.169.003H1.318A1.326 1.326 0 0 1 0 12c0-.703.538-1.279 1.22-1.33l.098-.004h23.07a1.981 1.981 0 0 0 1.908-1.483 2.009 2.009 0 0 0-.922-2.248 1.96 1.96 0 0 0-2.293.228l-.093.088c-.515.52-1.35.519-1.864-.002a1.344 1.344 0 0 1 .002-1.886 4.576 4.576 0 0 1 5.567-.737ZM15.17.535a4.019 4.019 0 0 1 1.843 4.508c-.453 1.698-1.947 2.89-3.668 2.955L13.184 8H1.318A1.326 1.326 0 0 1 0 6.667c0-.703.538-1.28 1.22-1.33l.098-.004H13.19a1.32 1.32 0 0 0 1.278-.985 1.34 1.34 0 0 0-.614-1.502 1.307 1.307 0 0 0-1.512.138l-.082.077a1.308 1.308 0 0 1-1.864.005 1.344 1.344 0 0 1-.006-1.886 3.922 3.922 0 0 1 4.78-.645Z",
    fill: "currentColor"
  })));
};

export default SvgWind;